import React from 'react';
import PropTypes from 'prop-types';
import { Tabs as Container, Tab } from './styles';

const Tabs = ({ items, onClick, selected, tabIndex = '0' }) => {
  return (
    <Container>
      {items.map(({ value, name }) => (
        <Tab
          key={value}
          onClick={() => onClick(value)}
          className={value === selected ? 'selected' : null}
          tabIndex={tabIndex}
        >
          {name}
        </Tab>
      ))}
    </Container>
  );
};

Tabs.propTypes = {
  items: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  tabIndex: PropTypes.string
};

export default Tabs;
